module.exports = __webpack_public_path__ + "img/CeeYuu_Logo_horizontal.a03617e5.png";